import { Component, type ReactNode } from 'react';

import { ServerErrorPage } from './ServerErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    const details =
      import.meta.env.DEV && error.stack ? error.stack : `${error.name}: ${error.message}`;
    return <ServerErrorPage details={details} />;
  }
}
